import { LayerType } from "@cloud-twin-v2/generated/simulation.generated.client";
import { MapGenericStyle } from "@common-modules/wlm-map/generic-map/models/map-generic-style";

export const DEFAULT_LAYER_STYLES = new Map<string, MapGenericStyle>([
  [
    LayerType.Point,
    {
      styleName: "DEFAULT",
      styleDefinition: {
        className: [],
        definition: { Fill: "#1e6ab1" }
      }
    }
  ]
]);
